export const FILTERS = {
  action: "Actions",
  view: "Viewed Job",
  status: "Status Change",
  edit: "Edit",
  smsCall: "SMS / Call",
  email: "Email",
} as const;
